import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[containerMask]',
  standalone: false
})
export class ContainerMaskDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = this.el.nativeElement;
    let raw = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');

    const letters = raw.slice(0, 4).replace(/[^A-Z]/g, '');
    const numbers = raw.slice(4).replace(/[^0-9]/g, '');

    let masked = letters;

    if (letters.length === 4 && numbers.length > 0) {
      masked += ' ';
      masked += numbers.slice(0, 6);
    }

    if (numbers.length >= 7) {
      masked += '-' + numbers.charAt(6);
    }

    input.value = masked;
  }

  @HostListener('blur')
  onBlur(): void {
    const input = this.el.nativeElement;
    const valid = /^[A-Z]{4} \d{6}-\d{1}$/.test(input.value);
    if (!valid) {
      input.value = '';
    }
  }
}
